import * as React from 'react'
import { DataTable } from 'damco-components'
import styled from 'styled-components'
const CustomDataTable = styled.div`
    .grid-toolbar-data-table {
        display: none
    }
`
interface IProps {
    data: any[];
    distributionType:number;
    cols: any[];
    isSelectable:boolean;
    subTableRef:any;
    targetLevel: number;
    onchange: (value:boolean, list:any[]) => void;
    onChildTableUpdate: () => void
    updateTable: boolean,
    className: string
}
interface IState {
    isSelectable:boolean,
    selectedList: boolean[]
}
export class DialogSubTableWrapperNew extends React.Component<IProps, IState> {
  public myTable:any = React.createRef<HTMLDivElement>()
  public state = {
    isSelectable: false,
    selectedList: []
  }
  constructor(props:IProps) {
    super(props)
  }
  public componentDidMount (){
    if(this.myTable.current && this.props.subTableRef.current){
      this.myTable.current.addEventListener('click', this.clickEventHandler)
    }
    if(this.props.isSelectable){
      this.isSelectable()
    }
  }
  public componentWillUnmount(){
    this.myTable.current.removeEventListener('click', this.clickEventHandler)
  }
  public componentDidUpdate (props:IProps){
    if(props.isSelectable !== this.props.isSelectable){
      this.isSelectable()
    }
    if(this.props.updateTable){
      this.updateSelectedState()
    }
  }
  public updateSelectedState = () =>{
    this.props.data?.forEach((obj:any, idx:number)=>{
      if(obj.select){
        this.props.subTableRef.current.setSelectedItems([idx])
      }
    })
    this.props.subTableRef.current.updateSelectAll()
    this.props.onChildTableUpdate()
  }
  public isSelectable = () =>{
    if(this.props.isSelectable && this.props.distributionType > 0){
      const dataList = this.props.subTableRef.current.getData()
      const selectionState = dataList.every((element:any) => element.select===undefined)
      if(selectionState){
        this.props.subTableRef.current.toggleSelectAll()
        this.props.onchange(true, [])
      }
      else{
        this.updateSelectedState()
      }
    }
  }
  public selectedList = () =>{
    const dataList = this.props.subTableRef.current.getData()
    const arrResp:any[] = []
    setTimeout(()=>{
      const selectedList = this.props.subTableRef.current.getSelectedItems()
      dataList.forEach((obj:any)=>{
        arrResp.push(selectedList.includes(obj,0))
      })
      this.props.onchange(true, arrResp)
    }, 10)
  }
  public clickEventHandler = (ev:any) => {
    if (ev.target.matches('input.checkbox.grid-checkbox')) {
      if(ev.target.parentNode.matches('div.rt-resizable-header-content')){ // selectAll checkbox
        this.props.subTableRef.current.toggleSelectAll()
        this.props.onchange(ev.target.checked, [])
      }else{  // each row checkbox
        this.selectedList()
      }
    }
  }
  public render() {
    if(this.props.data.length > 0 && this.props.targetLevel){
      return(
        <div ref={this.myTable}>
          <CustomDataTable>
            <DataTable
              data={this.props.data}
              columns={this.props.cols}
              isEditable={false}
              isSelectable={this.props.isSelectable}
              selectedOption="multiple"
              isSortable={true}
              isExpandable={false}
              isResizable={true}
              hasFooter={false}
              ref={this.props.subTableRef}
              showColumnOptions={false}
              defaultPageSize={100}
              tableName={this.props.className}
              showPagination={this.props.data.length && this.props.data.length> 100? true: false}
            />
          </CustomDataTable>
        </div>
      )
    }else{
      return <div/>
    }
  }
}